import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ChannelService from "../../../services/KangarooServices/Intelligence/ChannelService";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import {
  Card,
  Col,
  Container,
  Row,
  Button,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
  CardBody,
} from "reactstrap";
import { imageBaseApi } from "../../../utilis/imageHelper";
import toast from "react-hot-toast";

const UnassignInstitute = () => {
  const { id } = useParams(); // channel partner ID
  const navigate = useNavigate();

  const [assignedUniversities, setAssignedUniversities] = useState([]);
  const [selectedUniversities, setSelectedUniversities] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 24;

  // Fetch assigned universities for this channel partner
  const fetchAssignedUniversities = async () => {
    setLoading(true);
    try {
      const response = await ChannelService.getdetails(id);

      setAssignedUniversities(response?.universities || []);
      setSelectedUniversities([]); // reset selection
    } catch {
      toast.error("Failed to fetch assigned universities");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAssignedUniversities();
  }, [id]);

  // Toggle selection
  const toggleSelectUniversity = (uni) => {
    setSelectedUniversities((prev) =>
      prev.some((i) => i.id === uni.id)
        ? prev.filter((i) => i.id !== uni.id)
        : [...prev, uni],
    );
  };

  const isSelected = (uni) => selectedUniversities.some((i) => i.id === uni.id);

  // Handle Unassign submit
  const handleUnassignSubmit = async () => {
    if (!selectedUniversities.length) {
      toast.error("Please select at least one university to unassign");
      return;
    }

    const payload = {
      channelPartnerId: id,
      universityIds: selectedUniversities.map((i) => i.id),
    };

    try {
      await ChannelService.createUnAssignUni(payload);
      toast.success("Selected universities unassigned successfully!");
      fetchAssignedUniversities();
      setCurrentPage(1);
      // navigate(`/assign-institute/${id}`);
      navigate(`/channel-partners`);
    } catch {
      toast.error("Failed to unassign universities");
    }
  };

  /* FILTERED & PAGINATED LIST */
  const filteredUniversities = assignedUniversities.filter((uni) =>
    uni.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const totalPages = Math.ceil(filteredUniversities.length / itemsPerPage);

  const paginatedUniversities = filteredUniversities.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  // Reset page when search term changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Unassign Institutes"
          pageTitle="Channel Partner"
          breadcrumbItems={[
            { title: "Back to List", link: "/channel-partners" },
          ]}
        />

        <Row className="mb-3 d-flex align-items-center gap-2">
          <Col lg={4}>
            <Input
              placeholder="Search assigned institutes"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Col>

          <Col lg={2}>
            <Button color="danger" onClick={handleUnassignSubmit}>
              Unassign Institute
            </Button>
          </Col>
        </Row>

        {selectedUniversities.length > 0 && (
          <Row className="mb-3">
            <Col>
              <div className="p-2 bg-light rounded d-flex flex-wrap align-items-center">
                <strong className="me-2">Selected to Unassign:</strong>
                {selectedUniversities.map((uni) => (
                  <span
                    key={uni.id}
                    className="badge bg-danger me-1 mb-1 d-flex align-items-center"
                    style={{ fontSize: "0.85rem", cursor: "pointer" }}
                    onClick={() =>
                      setSelectedUniversities((prev) =>
                        prev.filter((i) => i.id !== uni.id),
                      )
                    }
                  >
                    {uni.name} ×
                  </span>
                ))}
              </div>
            </Col>
          </Row>
        )}

        {/* Universities Grid */}
        <Row className="g-3 mt-3">
          {!loading &&
            paginatedUniversities.map((uni) => (
              <Col xl={2} lg={3} md={4} sm={6} key={uni.id}>
                <Card
                  onClick={() => toggleSelectUniversity(uni)}
                  className={`h-100 text-center p-2 ${
                    isSelected(uni) ? "border border-primary" : "border"
                  }`}
                  style={{ cursor: "pointer", borderRadius: "10px" }}
                >
                  <CardBody>
                    <img
                      src={`${imageBaseApi}${uni.logo?.url}`}
                      alt={uni.name}
                      style={{ height: 100, objectFit: "contain" }}
                      className="mb-2 img-fluid"
                    />
                    <h6 className="text-truncate mb-0">{uni.name}</h6>
                  </CardBody>
                </Card>
              </Col>
            ))}
        </Row>

        {/* Pagination */}
        {totalPages > 1 && (
          <Row className="mt-4">
            <Col className="d-flex justify-content-center">
              <Pagination>
                <PaginationItem disabled={currentPage === 1}>
                  <PaginationLink
                    previous
                    onClick={() => setCurrentPage(currentPage - 1)}
                  />
                </PaginationItem>

                {[...Array(totalPages)].map((_, index) => (
                  <PaginationItem
                    key={index}
                    active={currentPage === index + 1}
                  >
                    <PaginationLink onClick={() => setCurrentPage(index + 1)}>
                      {index + 1}
                    </PaginationLink>
                  </PaginationItem>
                ))}

                <PaginationItem disabled={currentPage === totalPages}>
                  <PaginationLink
                    next
                    onClick={() => setCurrentPage(currentPage + 1)}
                  />
                </PaginationItem>
              </Pagination>
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
};

export default UnassignInstitute;
